import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  couponCodes: [],
  popularItems: [],
  name: '',
  seoDescriptions: [],
  isLoaded: false,
};

export const shopCouponCodesSlice = createSlice({
  name: 'shopCouponCodes',
  initialState,
  reducers: {
    receiveShopData: (_, { payload: { couponCodes, popularItems, name, seoDescriptions } }) => ({
      couponCodes,
      popularItems,
      name,
      seoDescriptions,
      isLoaded: true,
    }),
    resetShopData: () => initialState,
  },
});

export default shopCouponCodesSlice.reducer;
